import { FC, useMemo } from 'react';
import { Date } from 'shared/ui';
import { useEventStore } from '../../model';

export const EventDate: FC<{ id?: number; date?: Date }> = ({ id, date }) => {
  const eventsMap = useEventStore(state => state.map);
  const eventDate = useMemo(() => {
    return date ?? (id ? eventsMap.get(id)?.date : undefined);
  }, [date, eventsMap, id]);

  return (
    <>{eventDate && <Date date={eventDate} pattern="dd.MM.yyyy, HH:mm " />}</>
  );
};
